import { Flex, HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsBannerShown } from '../../../app-state/slices/AppDataSlice';
import { RootState } from '../../../app-state/store';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import {
    useCheckForMobile,
    useCheckForMobileOrTablet,
    useCheckForTablet,
} from '../../hooks/UseResponsive/UseResponsive';
import ActClose from '../Icons/ActClose';

const CanopyManagerBanner = ({ t }: any) => {
    const currentColors = useCurrentColors();
    const isMobile = useCheckForMobile();
    const isTablet = useCheckForTablet();
    const isMobileOrTablet = useCheckForMobileOrTablet();
    const dispatch = useDispatch();
    const {
        appData: { isBannerShown },
    } = useSelector((state: RootState) => state);

    const handleOnClose = () => {
        dispatch(setIsBannerShown(false));
    };

    if (!isBannerShown) {
        return null;
    }

    return (
        <>
            <Flex
                alignItems="center"
                justifyContent="center"
                width={isMobileOrTablet ? '100%' : 'calc(100% - 80px)'}
                marginLeft={!isMobileOrTablet ? '-20px' : '0px'}
                zIndex="200"
                position="fixed"
                p={isMobile ? '0px' : isTablet ? '20px' : '10px'}
                height="auto"
                bg={currentColors?.primaryColor}>
                <Flex>
                    <HStack>
                        <VStack px="10px">
                            <Text
                                color={currentColors.white}
                                fontSize={
                                    isMobile ? '12px' : isTablet ? 'md' : '18px'
                                }>
                                {t('ui.mm.banner.text')}
                                <a
                                    href={process.env.REACT_APP_CM_WRITEUP}
                                    target="_blank"
                                    rel="noreferrer">
                                    <u>{t('banner-button-text')}</u>
                                </a>
                            </Text>
                            <Flex
                                mt="0 !important"
                                color={currentColors.white}
                                fontSize={
                                    isMobile ? '12px' : isTablet ? 'md' : '18px'
                                }>
                                <Text
                                    dangerouslySetInnerHTML={{
                                        __html: t('ui.mm.banner.sub-text2', {
                                            interpolation: {
                                                escapeValue: false,
                                            },
                                            visualizerLink: '/',
                                        }),
                                    }}></Text>
                            </Flex>
                        </VStack>
                    </HStack>
                </Flex>
            </Flex>
            <Flex
                position="fixed"
                zIndex="200"
                top="20px"
                right="20px">
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    display="inline-flex"
                    onClick={handleOnClose}
                    color={currentColors.white}
                    width="20px"
                    minWidth="20px"
                    height="20px"
                    aria-label="remove"
                    icon={<ActClose />}
                    variant="ghost"
                    alignSelf="flex-start"
                    _hover={{ backgroundColor: 'transparent' }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{ border: '0px' }}
                />
            </Flex>
        </>
    );
};

export default CanopyManagerBanner;
